<template>
  <b-card>
    <admin-form :user="user" @updateCodes="getIfB3Codes" />
  </b-card>
</template>

<script>
import { BCard, BButton, BInputGroup, BInputGroupAppend, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Datatable from '@/views/common/crud/components/Datatable.vue'
import AdminForm from '@/views/admin/admins/components/AdminForm.vue'
import InviteCard from '@/views/admin/admins/components/InviteCard.vue'

export default {
  name: 'EditUserPage',
  components: {
    vSelect,
    BCard,
    BButton,
    Datatable,
    BFormInput,
    AdminForm,
    InviteCard,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      user: {},
    }
  },
  async mounted() {
    await this.getAdmin()
  },
  methods: {
    async getAdmin() {
      const { data } = await this.$store.dispatch('admin/getUser', this.$route.params.id)
      this.user = data.data
    }
  },
}
</script>

<style lang="scss"></style>
